import { RESULT_OPTIONS } from '@/pages/admin/followUpShipments/constants/resultOptions';
import {
	CloseButton,
	Form,
	InputField,
	Select,
	SubmitButton,
	Window,
	Wrapper,
} from './NewCommentModal.styles';

const NewCommentModal = ({ closeFunction, onSubmit }) => {
	return (
		<Wrapper>
			<Window>
				<CloseButton
					className='fa-solid fa-xmark'
					onClick={closeFunction}
				></CloseButton>

				<h2>Add call result</h2>
				<Form onSubmit={onSubmit}>
					<InputField>
						<label htmlFor='result'>Result</label>
						<Select name='result' id='result'>
							<option value='' default></option>
							{RESULT_OPTIONS.map((option) => (
								<option key={option} value={option}>
									{option}
								</option>
							))}
						</Select>
					</InputField>
					<InputField>
						<label htmlFor='comment'>Comment</label>
						<input id='comment' type='text' />
					</InputField>
					<SubmitButton type='submit' />
				</Form>
			</Window>
		</Wrapper>
	);
};

export default NewCommentModal;
